<template>
<div class="layer-project" data-project-name="partecs"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit">Hyundai Partecs</h1>
                <a href="http://www.partecs.co.kr" class="link" target="_blank">www.partecs.co.kr</a>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">현대파텍스는 생산이 종료된 차량에 대한 차체 부품을 제조, 공급하는 단산 차 A/S 부품 전문공장으로 고객을 위한 기업의 이미지를 전달하기 위한 <span>비주얼 이미지를 사용하여 시각적으로 표현했습니다. 현대자동차그룹의 WSG를 적용하여 그룹의 아이덴티티를 유지하여 제작되었습니다.</span></p>
                <div class="project-overview-diagram">
                    <p class="diagram01">HYUNDAI PARTECS <br>creates a batter world <br>together with customers.</p>
                    <p class="diagram02">
                        <ul>
                            <li class="item01">Sound Growth <br>Focused on <br>Core-Biz.&amp;Tech.</li>
                            <li class="item02">Excellent Quality Based on <br>High Efficiency</li>
                            <li class="item03">Safety First &amp; <br>Reliable Harmony</li>
                        </ul>
                    </p>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="section section01">
            <div class="inner-section">
                <strong class="project-subtit">PC Web</strong>
                <p class="sub-text">현대자동차그룹의 WSG를 적용한 Column Layout으로 구성하여 키 비주얼 및 다양한 콘텐츠를 구성했습니다. <br>육각형 형태의 그래픽 모티브를 활용하여 유기적으로 협업하는 기업의 이미지를 강조했습니다.</p>
                <div class="pc-web-img">
                    <img src="" alt="" data-src="/static/img/project-detail/partecs/pc-web-img@m.png">
                </div>
            </div>
        </section>        
        <section class="section section02">
            <div class="inner-section">
                <p class="sub-text">좌측메뉴에 현재 페이지의 위치를 표시하여 쉽게 <span class="ib">파악할 수 있으며,</span> <span>상단부터 콘텐츠가 시작하여 콘텐츠 영역이 더욱 강조되었습니다.</span> <br>콘텐츠 페이지는 메인과 통일감을 주기 위해 육각형의 그래픽을 활용하여 디자인했습니다.</p>
                <div class="pc-web clfix">
                    <div class="item01">
                        <img src="" alt="" data-src="/static/img/project-detail/partecs/pc-web-img01@m.png">
                    </div>
                    <div class="item02">
                        <img src="" alt="" data-src="/static/img/project-detail/partecs/pc-web-img02@m.png">
                    </div>
                    <div class="item03">
                        <img src="" alt="" data-src="/static/img/project-detail/partecs/pc-web-img03@m.png">
                    </div>
                </div>
            </div>
        </section>
        <section class="section section03">
            <div class="inner-section">
                <div class="point-area clfix">
                    <div class="point-font-area clfix">
                        <div class="point-font-title">
                            <img src="/static/img/project-detail/partecs/point-font-title@m.png" alt="">
                        </div>
                        <div class="point-font-text">
                            <img src="" alt="" data-src="/static/img/project-detail/partecs/point-font-text@m.png">
                        </div>
                    </div>                
                    <div class="point-color-area">
                        <div>
                            <img src="" alt="" data-src="/static/img/project-detail/partecs/point-color@m.png">
                        </div>
                    </div>   
                </div>             
                <div class="point-icon-area">
                    <ul>
                        <li class="item01"><img src="/static/img/project-detail/partecs/point-icon01@m.png" alt=""></li>
                        <li class="item02"><img src="/static/img/project-detail/partecs/point-icon02@m.png" alt=""></li>
                        <li class="item03"><img src="/static/img/project-detail/partecs/point-icon03@m.png" alt=""></li>
                        <li class="item04"><img src="/static/img/project-detail/partecs/point-icon04@m.png" alt=""></li>
                        <li class="item05"><img src="/static/img/project-detail/partecs/point-icon05@m.png" alt=""></li>
                        <li class="item06"><img src="/static/img/project-detail/partecs/point-icon06@m.png" alt=""></li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="project-client"><strong class="a11y-hidden">Hyundai Partecs</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.section {
	background-color: #e6e6e6;
}
.sub-text {
	word-break: keep-all;
}
.project-tit {
	text-transform: uppercase;
}
.project-subtit {
	position: relative;
	margin-bottom: 0;
}
.sub-text {
	position: relative;
	padding-bottom: 25px;
	line-height: 2.35rem;
}
@media screen and (min-width: 1280px) {
	.sub-text {
		padding-bottom: 35px;
		font-size: 16px;
		line-height: 1.8;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #eee url(/static/img/project-detail/partecs/ci.png) 50% / auto
		42px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/partecs/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/partecs/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/partecs/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 84px;
	}
}

/* Overview */
.project-overview {
	background-color: #16348e;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 55px;
	line-height: 2.35rem;
	font-weight: 500;
}
.project-overview-diagram {
	line-height: 1.7rem;
	text-align: center;
}
.diagram01:after {
	content: "";
	display: block;
	width: 15px;
	height: 15px;
	margin: 25px auto 20px;
	border-right: 1px solid #fff;
	border-bottom: 1px solid #fff;
	transform: rotate(45deg);
}
.diagram02 li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 125px;
	height: 144px;
	background: url(/static/img/project-detail/partecs/diagram-bg@m.png) no-repeat;
	background-size: 100% auto;
}
@media screen and (max-width: 711px) {
	.diagram02 ul {
		position: relative;
		width: 260px;
		margin: 0 auto;
		padding-bottom: 118px;
	}
	.diagram02 li {
		margin: 0 auto;
	}
	.diagram02 .item02,
	.diagram02 .item03 {
		position: absolute;
		bottom: 0;
	}
	.diagram02 .item02 {
		left: 0;
	}
	.diagram02 .item03 {
		right: 0;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 27px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: space-between;
		max-width: 632px;
		margin: 0 auto;
	}
	.diagram01 {
		display: flex;
		align-items: center;
		position: relative;
		width: 236px;
		padding-right: 75px;
		text-align: left;
	}
	.diagram01:after {
		position: absolute;
		top: 50%;
		right: 35px;
		margin: 0;
		transform: translateY(-50%) rotate(-45deg);
	}
	.diagram02 {
		width: 396px;
	}
	.diagram02 ul {
		display: flex;
		justify-content: space-between;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		max-width: 1280px;
		margin: 0 auto;
		padding-bottom: 40px;
	}
	.project-overview-txt {
		margin-bottom: 60px;
		font-size: 16px;
		line-height: 1.8;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram {
		max-width: 970px;
	}
	.diagram01 {
		width: 326px;
		padding-right: 118px;
		font-size: 18px;
		line-height: 1.5;
	}
	.diagram01:after {
		right: 60px;
		width: 30px;
		height: 30px;
		border-right: 2px solid #fff;
		border-bottom: 2px solid #fff;
	}
	.diagram02 {
		width: 644px;
	}
	.diagram02 li {
		width: 208px;
		height: 240px;
		font-size: 20px;
		line-height: 1.5;
	}
}

/* pc web */
.section01 {
	overflow: hidden;
}
.pc-web-img {
	position: relative;
	padding-bottom: 43px;
	text-align: center;
}
.pc-web-img:before,
.pc-web-img:after {
	content: "";
	position: absolute;
}
.pc-web-img:before {
	top: 0;
	right: -20px;
	width: 183.5px;
	height: 75.5px;
	background: url(/static/img/project-detail/partecs/partecs-polygon01@m.png)
		no-repeat;
	background-size: 100% auto;
}
.pc-web-img:after {
	bottom: -40px;
	left: 22px;
	width: 169.5px;
	height: 107.5px;
	background: url(/static/img/project-detail/partecs/partecs-polygon02@m.png)
		no-repeat;
	background-size: 100% auto;
}
.pc-web-img img {
	position: relative;
	z-index: 1;
	box-shadow: 0 35px 30px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 711px) {
	.pc-web-img {
		margin-top: 15px;
		padding-top: 65px;
	}
}
@media screen and (min-width: 712px) {
	.section01 .inner-section {
		position: relative;
		padding-top: 43px;
	}
	.section01 .inner-section:before {
		content: "";
		position: absolute;
		top: -34px;
		left: -80px;
		width: 138px;
		height: 160px;
		background: url(/static/img/project-detail/partecs/partecs-polygon03@t.png)
			no-repeat;
		background-size: 100% auto;
	}
	.pc-web-img:before {
		top: -142px;
		right: -25px;
	}
	.pc-web-img:after {
		bottom: -40px;
		left: -70px;
		width: 243px;
		height: 154.5px;
		background-image: url(/static/img/project-detail/partecs/partecs-polygon02@t.png);
	}
}
@media screen and (min-width: 1280px) {
	.section01 .inner-section {
		padding-top: 90px;
	}
	.section01 .inner-section:before {
		top: -82px;
		left: -175px;
		width: 307px;
		height: 356px;
		background-image: url(/static/img/project-detail/partecs/partecs-polygon03@w.png);
	}
	.pc-web-img {
		padding-bottom: 256px;
	}
	.pc-web-img:before {
		top: -209px;
		right: -162px;
		width: 408px;
		height: 168px;
		background-image: url(/static/img/project-detail/partecs/partecs-polygon01@w.png);
	}
	.pc-web-img:after {
		bottom: 50px;
		left: -140px;
		width: 486px;
		height: 309px;
		background-image: url(/static/img/project-detail/partecs/partecs-polygon02@w.png);
	}
	.pc-web-img img {
		box-shadow: 0 70px 60px rgba(0, 0, 0, 0.1);
	}
}

.pc-web {
	padding-bottom: 20px;
	text-align: center;
}
.pc-web > div {
	padding-bottom: 15px;
}
.pc-web img {
	box-shadow: 0 35px 30px rgba(0, 0, 0, 0.1);
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		position: relative;
		padding-left: 0;
		padding-right: 0;
	}
	.section02 .inner-section:before {
		content: "";
		position: absolute;
		top: 30.8988vw;
		right: -128px;
		width: 145px;
		height: 132px;
		background: url(/static/img/project-detail/partecs/partecs-polygon04@t.png)
			no-repeat;
		background-size: 100% auto;
	}
	.section02 .sub-text {
		position: absolute;
		top: 0;
		left: 0;
		width: 42.4157vw;
	}
	.pc-web {
		position: relative;
	}
	.pc-web > div {
		width: 42.4157vw;
		padding-bottom: 30px;
	}
	.section02 .item01,
	.section02 .item03 {
		float: right;
	}
	.section02 .item02 {
		float: left;
		margin-top: 20.3651vw;
	}
}
@media screen and (min-width: 1280px) {
	.section.section02 {
		padding-left: 0;
		padding-right: 0;
	}
	.section02 .inner-section {
		padding-left: 20px;
		padding-right: 20px;
	}
	.section02 .inner-section:before {
		top: 456px;
		right: -246px;
		width: 290px;
		height: 264px;
		background-image: url(/static/img/project-detail/partecs/partecs-polygon04@w.png);
	}
	.section02 .item02 {
		margin-top: 268px;
	}
	.section02 .sub-text {
		left: 20px;
		width: 626px;
	}
	.section02 .sub-text span:not(.ib) {
		display: inline-block;
	}
	.pc-web {
		padding-bottom: 70px;
	}
	.pc-web > div {
		width: 607px;
		padding-bottom: 30px;
	}
	.pc-web img {
		box-shadow: 0 70px 60px rgba(0, 0, 0, 0.1);
	}
}

.section03 {
	position: relative;
	background-color: #353945;
}
.section03:before {
	content: "";
	position: absolute;
	top: -20px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}
.section03 .inner-section {
	max-width: 632px;
	margin: 0 auto;
	padding-top: 20px;
}
.point-font-title {
	width: 38.4375vw;
	margin-bottom: 40px;
}
.point-font-text {
	width: 67.8125vw;
	margin-bottom: 40px;
}
.point-color-area {
	margin-bottom: 52px;
}
.point-color-area div {
	text-align: center;
}
.point-color-area div img {
	width: 58.90625vw;
}
.point-icon-area ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}
.point-icon-area li {
	width: 67.5px;
	margin: 0 12px 20px;
}
@media screen and (min-width: 712px) {
	.section03:before {
		top: -50px;
		height: 100px;
	}
	.point-area {
		margin-bottom: 40px;
	}
	.point-area > div {
		float: left;
	}
	.point-font-area {
		width: 345px;
	}
	.point-font-title {
		width: 123px;
		margin-bottom: 32px;
	}
	.point-font-text {
		width: 302px;
		margin-bottom: 0;
	}
	.point-color-area {
		width: 287px;
		margin-bottom: 0;
	}
	.point-color-area div img {
		width: 188.5px;
	}
	.point-icon-area ul {
		justify-content: flex-start;
	}
	.point-icon-area li {
		margin: 0;
	}
	.point-icon-area li + li {
		margin-left: 35px;
	}
}
@media screen and (min-width: 1280px) {
	.section03:before {
		top: -100px;
		left: calc(50% - 1px);
		width: 2px;
		height: 200px;
	}
	.section03 .inner-section {
		max-width: 1280px;
		padding: 80px 0 80px 48px;
	}
	.point-font-area {
		width: 719px;
	}
	.point-font-title {
		width: 246px;
	}
	.point-font-text {
		width: 604px;
	}
	.point-color-area {
		width: 513px;
	}
	.point-color-area div img {
		width: 377px;
	}
	.point-icon-area li {
		width: 135px;
	}
	.point-icon-area li + li {
		margin-left: 73px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/partecs.vue